export default {

    name: 'AppNavigation',

    render()
    {
        return (
            <div class="app-navigation">
                <ul>
                    <li>
                        <span>System</span>
                    </li>
                    <li>
                        <RouterLink to={{ name: 'home' }}>Status</RouterLink>
                    </li>
                    <li>
                        <RouterLink to={{ name: 'login.index' }}>Logins</RouterLink>
                    </li>
                    <li>
                        <RouterLink to={{ name: 'token.index' }}>Tokens</RouterLink>
                    </li>
                </ul>
                <ul>
                    <li>
                        <span>API</span>
                    </li>
                    <li>
                        <RouterLink to={{ name: 'message.index' }}>Messages</RouterLink>
                    </li>
                    <li>
                        <RouterLink to={{ name: 'task.index' }}>Tasks</RouterLink>
                    </li>
                </ul>
            </div>
        )
    }

}